import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { currencyInput } from '../../helpers/form-helpers';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { FormsValidators } from '../forms/validators/forms.validators';
import { Frequency } from '../../models/affordability-enums';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalStateService } from '../../services/modal-state.service';

@Component({
  selector: 'app-add-option-modal',
  styleUrls: ['add-option-modal.component.scss'],
  templateUrl: 'add-option-modal.component.html',
  imports: [FormsModule, ReactiveFormsModule, FormlyModule],
})
export class AddOptionModalComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly modalService = inject(NgbActiveModal);
  private readonly state = inject(ModalStateService);

  @ViewChild('modalContainer') public modalContainer: ElementRef<HTMLDivElement>;
  @Input() public title: string;
  @Input() public data: any;

  public form = new UntypedFormGroup({});
  public fields: FormlyFieldConfig[];
  public formOptions: FormlyFormOptions = {};

  public get options() {
    return this.state.options;
  }

  public ngOnInit() {
    const { optionLabel, options } = this.data;
    this.fields = [
      {
        key: 'category',
        type: 'select',
        props: {
          text: optionLabel,
          options,
          required: true,
        },
      },
      currencyInput('amount', 'Monthly amount', null, null, [FormsValidators.integer]),
    ];
  }

  public ngAfterViewInit() {
    if ('parentIFrame' in window) {
      (window['parentIFrame'] as any).getPageInfo((info) => {
        const modal = this.modalContainer.nativeElement;
        modal.style.top = `${Math.max(0, info.scrollTop - info.offsetTop) + 200}px`;
      });
    }

    const defaultFocusElRef = {
      container: this.modalContainer,
    }['container'];
    defaultFocusElRef?.nativeElement?.focus();
  }

  public ngOnDestroy() {
    if ('parentIFrame' in window) {
      (window['parentIFrame'] as any).getPageInfo(false);
    }
  }

  public submit() {
    if (this.form.valid) {
      const { category, amount } = this.form.value;
      this.data.model.push({ option: { category, amount, frequency: Frequency.Monthly, optional: true } });
      this.modalService.close();
    }
  }

  public cancel() {
    this.modalService.dismiss();
  }
}
